
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSignArrowUpLeft as ObiSignArrowUpLeftElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sign-arrow-up-left.js';
 
 
 

 
 export const ObiSignArrowUpLeft = createComponent({
   react: React,
   tagName: 'obi-sign-arrow-up-left',
   elementClass: ObiSignArrowUpLeftElement,
   events: {
     
   }
  });
 
 